<template>
  <div class="animated fadeIn list-of-unearnsettle">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="deleteConfirm"
              ><i class="fa fa-trash"></i> Delete</b-dropdown-item
            >
          </b-dropdown>
          <b-button variant="primary mr-1" @click="approvalConfirm"
            ><i class="fa fa-send"></i> Send Approval</b-button
          >
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i>Export</b-button
          >
          <!-- <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button> -->
          <b-button variant="danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-2">
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-custome"
                    >Allocation Date</label
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.optiondate"
                  :plain="true"
                  :options="dateOpt"
                ></b-form-select>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend
                  ><span class="input-group-text"
                    >until</span
                  ></b-input-group-prepend
                >
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-custome"
                    >Debitur</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.CustName"
                  placeholder="Debitur Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-custome"
                    >Debitur No. (CIF)</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.CustCode"
                  placeholder="Debitur No"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-custome"
                    >No. Kontark</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.no_kontrak"
                  placeholder="Kontrak Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-custome"
                    >No Agreement</label
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.no_agreement"
                  placeholder="Agreement No"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 115px"
                >Description</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.settleuraian"></b-form-input>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="12">
              <div class="text-right">
                <b-button variant="success" @click="refresh()">
                  <i class="fa fa-refresh"></i> Apply Filter</b-button
                >
                <b-button
                  variant="secondary"
                  class="ml-2"
                  @click="clearFilter()"
                  >Clear Filter</b-button
                >
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <!-- <template v-slot:cell(action)="data">
        <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowUnPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>  -->
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(tglsettl)="data">
          {{ data.item.tglsettl | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(post_date)="data">
          {{ data.item.post_date | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(pbb_settle)="data">
          {{ data.item.pbb_settle | numFormat("0,0.00") }}
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group
            label-cols="4"
            label="Limit per page"
            style="margin-top: 0 !important"
          >
            <b-form-select
              :options="[10, 15, 20, 25]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showDelConfirm"
      title="Delete Record?"
      :centered="true"
      @ok="deleteData"
    >
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal
      v-model="showPostingConfirm"
      title="Posting Record?"
      :centered="true"
      @ok="postingData"
    >
      <p class="mb-1">
        The selected a row of data will be Posted to Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        You can unpost as long as <strong>Accounting Periode</strong> stil open
      </p>
    </b-modal>
    <b-modal
      v-model="showUnpostConfirm"
      title="Un Posting Record?"
      :centered="true"
      @ok="unpostData"
    >
      <p class="mb-1">
        The selected a row of data will be UnPosted from Accounting?
      </p>
      <p class="font-weight-bold m-0 text-danger">
        Data Journal will be removed from <strong>Accounting</strong>
      </p>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      hide-footer
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button
          variant="primary"
          v-if="isprintjv == true"
          @click.stop="editjv"
          >Edit Journal</b-button
        >
        <b-button variant="secondary" class="ml-2" @click="showReport = false">
          Close</b-button
        >
      </b-row>
    </b-modal>
    <b-modal
      v-model="showVoidConfirm"
      title="Void Transcation?"
      :centered="true"
      @ok="voidData"
    >
      <p class="mb-1">1 record is about to be Void/Canceled/Reversed</p>
      <p class="font-weight-bold m-0 text-danger">
        Are you sure to doing this ?
      </p>
    </b-modal>

    <b-modal
      v-model="showApprovalConfirm"
      header-bg-variant="primary"
      title="Approval Form - Payment Reverse"
      size="lg"
      :centered="true"
      hide-footer
    >
      <b-row>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 140px"
                >Trx. No</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="model.paymrevno" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 140px"
                >Tanggal</label
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="model.tglpaym_format"
              readonly
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >No. Kontrak</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >No. Aggrement</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.no_agreement" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend
          ><label style="width: 140px"
            >Nama Debitur</label
          ></b-input-group-prepend
        >
        <b-form-input v-model="model.CustName" readonly></b-form-input>
      </b-input-group>
      <b-row>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 140px"
                >Revese Amt.</label
              ></b-input-group-prepend
            >
            <my-number
              class="form-control text-right"
              v-model="model.totalbyrb4"
              :precision="2"
              disabled
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>

      <div v-if="this.model.send2wf == 1">
        <label class="mt-3"><h6>Workflow process history</h6></label>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="220px">Assign Date</th>
                <th width="220px">Assign To</th>
                <!-- <th width="220px">State</th> -->
                <th width="120px">Action Take</th>
                <th>Comment</th>
                <th width="120px">Complete Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td>
                  {{ row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>{{ row.crewnik }} | {{ row.crewname }}</td>
                <!-- <td>{{row.state}}</td> -->
                <td>
                  {{ row.actiontake }}
                  <!-- <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p> -->
                </td>
                <td>{{ row.message }}</td>
                <td>
                  <span v-if="row.completeddate">{{
                    row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="subtotal"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row class="justify-content-center mt-1">
          <!-- <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button> -->
          <b-button
            variant="danger"
            class="ml-1"
            @click="showApprovalcancelConfirm = true"
          >
            <i class="fa fa-undo"></i> Cancel Approval</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
      <div no-body v-else>
        <label>Add Attachment</label>
        <b-form-file
          v-model="file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <div class="mt-3">
          Selected file: <strong>{{ file ? file.name : "" }}</strong>
        </div>
        <b-row class="justify-content-center mt-1" v-if="showConfirmNoFile">
          <label style="width: 260px !important"
            >Send without attachment, are you sure?</label
          >
          <b-form-radio-group v-model="confirmNoFile" class="ml-1">
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-row>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="approval"
            ><i class="fa fa-paper-plane"></i> Send to Workflow</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="showApprovalcancelConfirm"
      title="Remove from workflow Approval Process?"
      :centered="true"
      @ok="approvalUndo"
    >
      <p class="mb-1">
        The selected a row of data will be removed from Workflow?
      </p>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-unearnsettle {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
}
.label-custome {
  max-width: 110px;
}
</style>


<script>
import arsettlement from "../../apis/arsettlement";
import arsettlementvoid from "../../apis/arsettlementvoid";
import task from "../../apis/task";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showVoidConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading: false,
      isprintjv: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      // approval 
      showApprovalConfirm: false,
      showApprovalInfo: false,
      approvalHistory:[],
      showSppConfirm: false,
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalcancelConfirm: false,
      showExpiredConfirm:false,
      // =========
      model: {},
      items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: moment().format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        //tgl2:'2020-11-30',
        sortBy: "tglsettl",
        sortDesc: true,
        DimCol: "Dim1",
        collector_id: "",
        optiondate: "post",
      },
      dataList: {
        arPayment: dropdown.arPayment,
      },
      dateOpt: [
        { value: "post", text: "Post Date" },
        { value: "value", text: "Value Date" },
      ],
    };
  },
  components: { Loading,myNumber },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: "width:40px",
        //   thClass: "text-center",
        // },
        {
          key: "no_agreement",
          // variant: "danger",
          label: "No Agreement",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "Debitur No.",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          sortable: true,
        },
        {
          key: "tglsettl",
          label: "Value Date",
          sortable: true,
        },
        {
          key: "post_date",
          label: "Post Date",
          sortable: true,
        },
        {
          key: "settleuraian",
          label: "Description",
        },
        {
          key: "settleno",
          label: "Prepaid No.",
        },
        {
          key: "pbb_settle",
          label: "Prepaid Reversed",
          thStyle: "width:120px",
          // variant: "danger",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
         {
            key: "status_approval",
            label: "Status Approval",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
        {
          key: "createby",
          label: "Issued By",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        (d) => d.value === newval
      ).text;
    },
  },
  created: async function () {},
  methods: {
    data: async function (ctx) {
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.unearnsettle) {
        this.tblData[key] = filter.unearnsettle[key];
        filtered = true;
      }
      if (filtered === true) {
        this.tblData.tgl1 = filter.unearnsettle.tgl1 || "";
        this.tblData.tgl2 = filter.unearnsettle.tgl2 || "";
        this.showFilter = filtered;
        delete filter.unearnsettle;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await arsettlementvoid.prepaid_void(this.tblData);
      this.items = list;
      return list;
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.namabank = "";
      this.tblData.reference = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.customer = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
      this.tblData.tgldue1 = "";
      this.tblData.tgldue2 = "";
      this.tblData.status = "";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = [
        "uraian",
        "DimCol",
        "DimVal",
        "tgl1",
        "tgl2",
        "status",
        "nomor",
        "customer",
        "namabank",
        "reference",
        "tgldue1",
        "tgldue2",
      ];
      let filtered = false;
      const unearnsettle = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          unearnsettle[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        unearnsettle.page = this.tblData.page;
        unearnsettle.limit = this.tblData.limit;
        unearnsettle.sortBy = this.tblData.sortBy;
        unearnsettle.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.unearnsettle = unearnsettle;
        this.$store.commit("filter", filter);
      }
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.printjv();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    edit: function () {
      console.log("edit", this.model);
      if (this.model.settleKey) {
        this.saveFilter();
        if (this.model.settleno) {
          router.push({
            name: "loan.prepaidallocationform",
            params: {
              settleno: this.model.settleno,
              pinjamankey: this.model.pinjamankey,
              post_date: this.model.post_date,
              tglsettl: this.model.tglsettl,
            },
          });
        } else {
          router.push({
            name: "loan.prepaidallocationform",
            params: { settleKey: this.model.settleKey },
          });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.settleKey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      const data = await arsettlement.remove(this.model);
      toastr.success(`${data.settleno} has been deleted.`);
      this.refresh();
    },
    voidConfirm() {
      if (this.model.settleKey) {
        this.showVoidConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Void!");
      }
    },
    voidData: async function () {
      if (this.model.settleKey) {
        this.saveFilter();
        if (this.model.pbb_statustre == 3 || this.model.isvoid == 1) {
          toastr.warn("Transaksi sudah divoid.");
        } else {
          router.push(
            `reverse-prepaid-settlement-form/${this.model.settleKey}`
          );
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    rowClicked(record, index) {
      console.log("record", record);
      // if (this.model.settleKey == record.settleKey) {
      //     this.edit();
      // } else {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    posting: async function () {
      if (this.model) {
        if ((this.model.posting || 0) == 0) {
          this.showPostingConfirm = true;
        }
        if (this.model.posting == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Posted!");
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        console.log("model", this.model);
        await arsettlement.posting(this.model);
        // this.model.posting=1;
        // this.printjv();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await arsettlement.postingUndo(this.model);
        this.model.posting = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    editjv: function () {
      if (this.model.settleKey) {
        this.saveFilter();
        router.push({
          name: "loan.editjvfrm",
          params: {
            nomor: this.model.settleno,
            tanggal: this.model.tglsettl,
            kodejurnal: "ARSTTL",
          },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },

    printjv: async function () {
      if (this.model.settleKey) {
        // if ((this.model.posting || 0) == 0) {
        //       toastr.warn('Please do Posting first!');
        // }
        this.isLoading = true;
        try {
          if ((this.model.posting || 0) == 0) {
            await arsettlement.posting(this.model);
            this.model.posting = 1;
          }
          this.reportUrl = await arsettlement.printjv(this.model);
          this.isLoading = false;
          this.showReport = true;
          this.isprintjv = true;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        await arsettlement.exportXlsPrepaidAlloc(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    // ======================= APROVAL
    approvalConfirm: async function () {
        console.log('this.model',this.model);
        if (this.model.groupKey) {            
            if (this.model.send2wf==1) {
              this.approvalInfo();
            }
            this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
            this.model.submitdate = this.model.submitdate ? moment(this.model.submitdate).format('YYYY-MM-DD') : '';
            this.model.duedate_memo = this.model.duedate_memo ? moment(this.model.duedate_memo).format('YYYY-MM-DD') : '';

            this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.groupKey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await arsettlementvoid.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },

    approvalInfoConfirm: async function (record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      setTimeout(() => {
        this.approvalInfo();
      }, 500);
    },

    approvalInfo: async function () {
      if (this.model.settleKey) { 
          if (this.model.send2wf==1) {
            try {
              this.showApprovalInfo = true;
              const data = await task.approvalhistory({key: this.model.groupKey});
              this.approvalHistory=data;            
            } catch (error) {
              if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }                
            }
          } 
      }
    },
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await arsettlementvoid.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    // ==================================
    close() {
      router.push({ name: "loan.home" });
    },
  },
};
</script>
